import React from "react";
import { LANGS, useI18n } from "../lib/i18n.jsx";

export default function PdfLang({ value, onChange, className = "", testid = "pdf-lang" }) {
  const { t } = useI18n();
  return (
    <label className={`flex items-center gap-2 text-sm ${className}`}>
      <span className="text-[var(--text-3)] whitespace-nowrap">{t("pdf_lang")}:</span>
      <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
        className="h-9 border border-[var(--border)] rounded-md px-2 text-sm bg-[var(--bg)] min-w-0">
        {LANGS.map((l) => <option key={l.code} value={l.code}>{l.name}</option>)}
      </select>
    </label>
  );
}
